import React, { useState } from "react";
import { ScrollView, StyleSheet, View, TouchableOpacity } from "react-native";
import { useTheme } from "react-native-paper";
import { useFocusEffect, useNavigation } from "@react-navigation/native";
import i18n from "../../../i18n";
import { LanguageIcon, TermsIcon } from "../../../components/Icons";
import { IconType } from "../index";
import { mobUser } from "../../../mobx/MobUser";
import { mobAlert } from "../../../mobx/MobAlert";
import { Text } from "../../../utils/fontsLoader";

const Settings = () => {

  const [, forceUpdate] = useState({}); // FIX FOR RE RENDER ON LANGUAGE CHANGE 

  useFocusEffect(  // FIX FOR RE RENDER ON LANGUAGE CHANGE 
    React.useCallback(() => {
      forceUpdate({});
    }, [])
  );

  const navigation = useNavigation();
  const theme = useTheme();
  const styles = styleGen(theme);

  const handleLogout = () => {
    mobAlert.setAlert(
      i18n.t("pages.logout.modalTitle"),
      "",
      i18n.t("pages.logout.disconnect"),
      () => {
        mobUser.LogOut();
        mobAlert.closeAlert();
      }
    );
  };

  const iconSize = 24;

  const ICONS_LIST: IconType[] = [
    { icon: <LanguageIcon height={iconSize} width={iconSize} />, title: i18n.t("home.language"), page: "Language" },
    { icon: <TermsIcon height={iconSize} width={iconSize} />, title: i18n.t("home.terms"), page: "Terms" },
  ];

  return (
    <ScrollView contentContainerStyle={styles.container}>
      <View style={styles.buttonsContainer}>
        {ICONS_LIST.map((component: IconType, idx: number) => (
          <TouchableOpacity
            key={idx}
            style={[
              styles.button,
              idx === ICONS_LIST.length - 1 && styles.lastButton // Applique le style lastButton au dernier élément
            ]}
            onPress={() => component.onPress ? component.onPress() : navigation.navigate(component.page)}
          >
            <View style={styles.iconContainer}>{component.icon}</View>
            <Text style={styles.buttonText}>{component.title}</Text>
          </TouchableOpacity>
        ))}
      </View>
      <TouchableOpacity
        style={styles.termsButton}
        onPress={handleLogout}
      >
        <Text style={styles.termsButtonText}>{i18n.t("home.disconnect")}</Text>
      </TouchableOpacity>
    </ScrollView>
  );
};

const styleGen = (theme) => StyleSheet.create({
  container: {
    flexGrow: 1,
    backgroundColor: theme.colors.background,
    padding: 16,
  },
  buttonsContainer: {
    marginTop: 20,
    borderRadius: 8,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: theme.colors.outline,
  },
  button: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.outline,
  },
  lastButton: {
    borderBottomWidth: 0, // Supprime la bordure inférieure pour le dernier bouton
  },
  iconContainer: {
    marginRight: 16,
  },
  buttonText: {
    fontSize: 16,
    color: theme.colors.onBackground,
  },
  termsButton: {
    marginTop: 20,
    padding: 16,
    backgroundColor: theme.colors.background,
    borderRadius: 8,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#FF0000',
  },
  termsButtonText: {
    color: '#FF0000',
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default Settings;
